import { v4 as uuid } from 'uuid';
import { HttpClient } from 'api/http-client';
import { DiscussionsContainer, NewDicussion } from './types/document';

class DocumentDiscussionHttpClient extends HttpClient {
  public async getDiscussions(
    projectID: number,
    documentID: number,
  ): Promise<DiscussionsContainer> {
    return this.get<DiscussionsContainer>(
      `/projects/${projectID}/documents/${documentID}/discussions`,
    );
  }

  public async createDiscussionThread(
    projectID: number,
    documentID: number,
    comment: string,
    isPrivate: boolean,
  ) {
    const commentGuid = uuid();

    return this.post<
      NewDicussion,
      { comment: { content: string; private: boolean; commentGuid: string } }
    >(`/projects/${projectID}/documents/${documentID}/discussions`, {
      comment: {
        content: comment,
        private: isPrivate,
        commentGuid,
      },
    });
  }

  public async replyDiscussionThread(
    projectID: number,
    documentID: number,
    commentThreadId: number,
    comment: string,
    isPrivate: boolean,
  ) {
    const commentGuid = uuid();

    return this.post<
      NewDicussion,
      { comment: { content: string; private: boolean; commentGuid: string } }
    >(
      `/projects/${projectID}/documents/${documentID}/discussions/${commentThreadId}/comments`,
      {
        comment: {
          content: comment,
          private: isPrivate,
          commentGuid,
        },
      },
    );
  }

  public async editDiscussionComment(
    projectID: number,
    documentID: number,
    commentThreadId: number,
    commentId: number,
    content: string,
  ) {
    return this.put<NewDicussion, { comment: { content: string } }>(
      `/projects/${projectID}/documents/${documentID}/discussions/${commentThreadId}/comments/${commentId}`,
      {
        comment: {
          content,
        },
      },
    );
  }

  public async deleteDiscussionComment(
    projectID: number,
    documentID: number,
    commentThreadId: number,
    commentId: number,
  ) {
    return this.delete<NewDicussion, { comment: { content: string } }>(
      `/projects/${projectID}/documents/${documentID}/discussions/${commentThreadId}/comments/${commentId}`,
    );
  }

  public async deleteDiscussionThread(
    projectID: number,
    documentID: number,
    commentThreadId: number,
  ) {
    return this.delete<NewDicussion, { comment: { content: string } }>(
      `/projects/${projectID}/documents/${documentID}/discussions/${commentThreadId}`,
    );
  }

  public async resolveDiscussionThread(
    projectID: number,
    documentID: number,
    commentThreadId: number,
  ) {
    return this.put<NewDicussion, { resolved: boolean }>(
      `/projects/${projectID}/documents/${documentID}/discussions/${commentThreadId}`,
      {
        resolved: true,
      },
    );
  }
}

export const DocumentDiscussionAPI = new DocumentDiscussionHttpClient();
